import React from 'react';
import { Icon, IconProps } from '@material-ui/core';
import Search from './icon_input_airport.png';

export const AswSearch: React.FC<IconProps> = (props: IconProps) => {
  return (
    <Icon {...props}>
      <img src={Search} alt='Search' />
    </Icon>
  );
}

export default AswSearch;
